// Static, per-operator terms & conditions shown on the metro ticket detail.
// BMRCL (Namma Metro) is the only live metro operator and the only one issuing a dynamic gate QR,
// so a ticket's dynamic-QR flag is the reliable BMRCL signal. Its terms come from the operator's
// own published rules; other networks fall back to generic metro terms.

const BMRCL_TERMS: string[] = [
  'QR tickets are valid for entry only at the origin station for which the ticket was booked, and for exit at any station in the direction of travel up to the destination station.',
  'Mobile QR tickets must be presented within this authorised app. Photographs, screenshots, or copies of the ticket will not be accepted.',
  'Tickets are valid only for the same calendar day, within operational hours.',
  'If your phone is malfunctioning, has a dead battery, or is lost, you will be treated as ticketless and must purchase a physical ticket.',
  'If the QR ticket is expired or invalid at the entry gate, you will be treated as ticketless and must buy a new QR or physical ticket. At the exit gate, a new paper ticket may be chargeable or adjusted to zero as determined by the authorities.',
  'You can book up to 6 tickets at once — you receive a single QR code for the booking, regardless of the number of passengers.',
  'BMRCL operational hours: Monday to Sunday, 4:30 AM to 2:30 AM.',
];

const GENERIC_METRO_TERMS: string[] = [
  'Your QR ticket is valid only for the journey and passengers it was booked for.',
  'Present the QR within this authorised app — screenshots or copies may not be accepted at the gate.',
  'Tickets are valid for same-day travel within the operator’s service hours.',
];

/**
 * Terms & conditions for a metro ticket. `isBmrcl` (derived from the dynamic-QR flag) selects the
 * BMRCL rule set; everything else gets generic metro terms.
 */
export function metroTerms(isBmrcl: boolean): string[] {
  return isBmrcl ? BMRCL_TERMS : GENERIC_METRO_TERMS;
}
